<h3 mat-dialog-title>Upload</h3>
<div mat-dialog-content style="width: 100%">
    <p>
        Faça upload de um arquivo<br>        
        <br>
        <b>OBS.: O arquivo vai ser armazenado na pasta atual. Escolha uma das opções abaixo para compartilhar o arquivo.</b>
    </p>

    <mat-accordion *ngIf="usuario.tipo_usuario_id == 2 || usuario.tipo_usuario_id == 3 || usuario.tipo_usuario_id == 4 ">
        
        <!-- Escritório -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Permissão por Escritório
                </mat-panel-title>
                <mat-panel-description>
                    Compartilhar arquivos com escritórios
                </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-selection-list #grupos [(ngModel)]="selectedOptionsEscritorio" (ngModelChange)="onNgModelChangeEscritorio($event)" style="max-height: 200px; overflow: auto;">
                <mat-list-option *ngFor="let escritorio of listaEscritorio" [value]="escritorio.id">
                    {{escritorio.nome_fantasia}}
                </mat-list-option>
            </mat-selection-list>
        </mat-expansion-panel>
        
        <!-- Usuário -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Permissão por Usuário
                </mat-panel-title>
                <mat-panel-description>
                    Compartilhar arquivos por usuários
                </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field style="width: 100%;">
                <mat-select placeholder="Usuários" [formControl]="users" multiple (selectionChange)="onChangeUser()">
                    <mat-select-trigger>
                    {{users.value ? users.value[0] : ''}}
                    <span *ngIf="users.value?.length > 1" class="example-additional-selection">
                        (+{{users.value.length - 1}} {{users.value?.length === 2 ? 'other' : 'others'}})
                    </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let usuario of listaUsuario" [value]="usuario.id">{{usuario.name}}</mat-option>
                </mat-select>
            </mat-form-field>
              
        </mat-expansion-panel>
        
        <!-- Grupo -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Permissão por Grupo
                </mat-panel-title>
                <mat-panel-description>
                    Compartilhar arquivos com grupos de usuários 
                </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-selection-list #grupos [(ngModel)]="selectedOptions" (ngModelChange)="onNgModelChange($event)" style="max-height: 200px; overflow: auto;">
                <mat-list-option *ngFor="let grupo of listaGrupo" [value]="grupo.id">
                    {{grupo.name}}
                </mat-list-option>
            </mat-selection-list>
        </mat-expansion-panel>
    </mat-accordion>

    <input hidden type="file" #fileInput (change)="uploadFile($event)" accept=".xls,.xlsx" />
    <button mat-button (click)="fileInput.click()" tabindex="-1">
        <mat-icon>cloud_upload</mat-icon>
        Importar Arquivo
    </button>

    <p *ngIf="file">
        <b>{{ nomeFile }}</b> 
        <button type="button" mat-button tabindex="-1" (click)="removerArquivo()">X</button>
    </p>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button         
        type="button" 
        mat-button
        (click)="startUpload()" 
        tabindex="-1" >
        Enviar
    </button>
</div>
